import { helpers } from "../../../../packages/helpers";
import { isNull } from "../../../../packages/helpers/predicates";
import type { GetChatInfoResponse } from "./api-types";

const { getStringValue } = helpers.text;

type Return = {
  id: string | null;
};

export const getChatInfoData = (response: unknown): Return => {
  const res = response as GetChatInfoResponse;

  return {
    id: isNull(res?.data?.id) ? null : getStringValue(res?.data?.id),
  };
};
